import * as z from "zod";
import { PERSONAL_USE_POLICIES } from "../personalUse";
import { mutator } from "./mutator";

export const setSkillPersonalUse = mutator({
  schema: z.object({
    skillId: z.string(),
    personalUse: z.enum(PERSONAL_USE_POLICIES),
  }),
  resolve: {
    skill: { kind: "skill", from: "skillId" },
  },
  permissions: [
    {
      permission: "skill:write",
      scopeId: ({ args }) => args.skill.id,
    },
  ],
  fn: async ({ tx, args: { skill, personalUse } }) => {
    await tx.mutate.skills.update({ id: skill.id, personalUse });
  },
});
